import React, { useEffect, useState } from "react";
import { usePagination, DOTS } from "./usePagination";
// import classNames from "classnames";
import "./Pagination.scss";
import { toast } from "react-toastify";
import LocalStorageService from "../../utils/auth_service/AuthServiceStorage";

const Pagination = ({
  onPageChange,
  totalCount ,
  siblingCount = 1,
  currentPage,
  pageSize = 10,
  className, 
  }) => {
 
  const paginationRange = structuredClone(
    usePagination({
      currentPage,
      totalCount,
      pageSize,
      siblingCount,
    })
  );

  if (currentPage === 0 || paginationRange?.length < 2) {
    return null;
  }

  let lastPage = paginationRange[paginationRange?.length - 1];
 

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  const showPage =(e)=>{
    const input = document.getElementById("pagesearch");
    const pageNo=Number(input.value);
    if(pageNo>lastPage||pageNo<1)
      toast.error("No such page exists");
    else
    onPageChange(currentPage=pageNo);
    document.getElementById("pagesearch").value=""
  }

  return (
    <>
      <ul className="pagination-container d-flex justify-content-between p-0 mb-1">
        <li className={`pagination-item border ${currentPage===1 ?"disabled":""} `} onClick={onPrevious}>
          <div className="arrow left" />
        </li>
        <span className="d-flex">
          {paginationRange.map((pageNumber, index) => {
            if (pageNumber === DOTS) {
              return (
                //border-end
                <li className="pagination-item  dots" key={index}>
                  &#8230;
                </li>
              );
            }

            return (
              <li
                className={`pagination-item ${
                  pageNumber == currentPage ? "selected rounded-1" : ""
                }`}
                onClick={() => onPageChange(pageNumber)}
                key={index}
              >
                {pageNumber}
              </li>
            );
          })}
        </span>
        <li
          className={`pagination-item border ${
            lastPage === currentPage ? "disabled" : ""
          }`}
          onClick={lastPage === currentPage ? undefined : onNext}
          aria-disabled={lastPage === currentPage}
          tabIndex="0"
          role="button"
        >
          <div className="arrow right" />
        </li>
    
      </ul>

      <div className="d-flex justify-content-center ">
        <div className="rounded" style={{ boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)' ,border: "1px solid gray"}}>
          <input type="number" placeholder="page"  className="rounded-start border-0" min={1} 
          style={{outline: "none", width:"58px"}} id="pagesearch"/>
          <button className="text-20px text-black bg-primary p-y-1 rounded-end border-0" 
          style={{outline: "none"}} onClick={showPage}><i class="bi bi-search"></i></button>
        </div>
      </div>
    </>
    
  );
};

export default Pagination;
